export default {
  methods: {
    /**
   * Checks if the provided start and end dates form a valid period.
   * Returns true if either date is missing or if the start date is after the end date.
   *
   * @param {string|Date} startDate - The start date of the period.
   * @param {string|Date} endDate - The end date of the period.
   * @returns {boolean} True if the period is invalid, false otherwise.
   */
    validPeriods(startDate, endDate) {
      return !startDate || !endDate || startDate > endDate;
    },

  /**
   * Determines if the given time period is currently active based on its start and end dates.
   *
   * @param {Object} timePeriod - An object representing the time period, expected to have `StartDateTime` and `EndDateTime` properties in ISO string format.
   * @returns {boolean} Returns `true` if the current date and time is within the specified period, `false` otherwise.
   */
  isActivePeriod(timePeriod) {
      if (typeof timePeriod !== 'object' || Array.isArray(timePeriod)) return false;
      if (timePeriod === undefined || timePeriod === null || !timePeriod) return true;

      const currentDate = new Date().toISOString('en-US', { timeZone: 'Asia/Hong_Kong' });
      const startDate = timePeriod?.StartDateTime;
      const endDate = timePeriod?.EndDateTime;

      if (this.validPeriods(startDate, endDate)) return false;
      return currentDate >= startDate && currentDate <= endDate;
    },
  }
}
